var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{attrs:{"id":"hm-web"}},[_c('Header',{staticClass:"show-pc"}),_vm._v(" "),_c('HeaderH5',{staticClass:"show-h5"}),_vm._v(" "),_c('a-layout-content',{staticClass:"hm-web-content"},[_c('div',{staticClass:"hm-web-content__main"},[_c('router-view')],1)]),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('popover',{staticClass:"pop-over"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1716f47d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/pageView.vue
// module id = null
// module chunks = 